// src/pages/AdminCMS.js
import React, { useState } from 'react';
import './AdminCMS.css';
import AdminDashboard from '../components/AdminDashboard';
import UsersManagement from '../components/UsersManagement';
import MuralManagement from '../components/MuralManagement';
import EntrepreneurManagement from '../components/EntrepreneurManagement';
import NossosResultadosManagement from '../components/NossosResultadosManagement';
import ParceirosDaRedeManagement from '../components/ParceirosDaRedeManagement';
import NewsletterManagement from '../components/NewsletterManagement';
import ConversationsManagement from '../components/ConversationsManagement';
import CurriculumManagement from '../components/CurriculumManagement';

const AdminCMS = () => {
  const [activeComponent, setActiveComponent] = useState('dashboard');

  const handleMenuClick = (component) => {
    setActiveComponent(component);
  };

  return (
    <div className="admin-cms-container">
      <aside className="sidebar">
        <nav>
          <ul>
            <li onClick={() => handleMenuClick('dashboard')}>Dashboard</li>
            <li onClick={() => handleMenuClick('users')}>Users</li>
            <li onClick={() => handleMenuClick('mural')}>Mural</li>
            <li onClick={() => handleMenuClick('entrepreneur')}>Vitrine de Empreendedores</li>
            {/* TODO: reativar "Banco de Currículos" quando a feature estiver pronta */}
            {/* <li onClick={() => handleMenuClick('curriculum')}>Banco de Currículos</li> */}
            <li onClick={() => handleMenuClick('conversations')}>Conversas</li>
            <li onClick={() => handleMenuClick('nossosResultados')}>Nossos Resultados</li>
            <li onClick={() => handleMenuClick('parceiros')}>Parceiros da Rede</li>
            <li onClick={() => handleMenuClick('newsletter')}>Newsletter</li>
          </ul>
        </nav>
      </aside>
      <section className="dashboard">
        {activeComponent === 'dashboard' && <AdminDashboard />}
        {activeComponent === 'users' && <UsersManagement />}
        {activeComponent === 'mural' && <MuralManagement />}
        {activeComponent === 'entrepreneur' && <EntrepreneurManagement />}
        {activeComponent === 'curriculum' && <CurriculumManagement />}
        {activeComponent === 'conversations' && <ConversationsManagement />}
        {activeComponent === 'nossosResultados' && <NossosResultadosManagement />}
        {activeComponent === 'parceiros' && <ParceirosDaRedeManagement />}
        {activeComponent === 'newsletter' && <NewsletterManagement />}
      </section>
    </div>
  );
};

export default AdminCMS;
